__turbopack_context__.v({
  "addButtonWrapper": "-tgXlW_addButtonWrapper",
  "availability": "-tgXlW_availability",
  "availabilityWrapper": "-tgXlW_availabilityWrapper",
  "currentPrice": "-tgXlW_currentPrice",
  "iconSectionWrapper": "-tgXlW_iconSectionWrapper",
  "insideWrapper": "-tgXlW_insideWrapper",
  "oldPrice": "-tgXlW_oldPrice",
  "priceWrapper": "-tgXlW_priceWrapper",
  "producerName": "-tgXlW_producerName",
  "productAvailabilityParagraph": "-tgXlW_productAvailabilityParagraph",
  "productDetails": "-tgXlW_productDetails",
  "productName": "-tgXlW_productName",
  "productUnitDetails": "-tgXlW_productUnitDetails",
  "wrapper": "-tgXlW_wrapper",
});
